import { waffleIcon, churchIcon, franceIcon,switzerlandIcon,
austriaIcon,germanyIcon,italyIcon,
spainIcon,netherlandsIcon,irelandIcon,denmarkIcon,
slovakiaIcon,czechRepublicIcon,polandIcon,hungaryIcon,
greeceIcon,portugalIcon,ukIcon,
norwayIcon,swedenIcon,finlandIcon,icelandIcon,
estoniaIcon,latviaIcon,lithuaniaIcon,
croatiaIcon, sloveniaIcon, bosniaIcon, albaniaIcon, macedoniaIcon, 
bulgariaIcon, serbiaIcon, romaniaIcon, moldovaIcon,
montenegroIcon,kosovoIcon,
indiaIcon, uzbekistanIcon, turkeyIcon, malaysiaIcon,
 thailandIcon, indonesiaIcon,
georgiaIcon, azerbaijanIcon } from "./markerIcons";

export const visitedCountriesMarkers = [
  { name: "Belgium", coords: [50.640168, 4.666682], icon: waffleIcon },
  { name: "Iceland", coords: [64.9631, -19.0208], icon: churchIcon },
  { name: "France", coords: [46.227638, 2.213749], icon: franceIcon },
  { name: "Switzerland", coords: [46.818188, 8.227512], icon: switzerlandIcon },
  { name: "Austria", coords: [47.516231, 14.550072], icon: austriaIcon },
  { name: "Germany", coords: [51.165691, 10.451526], icon: germanyIcon },
  { name: "Georgia", coords: [42.3154, 43.3569], icon: georgiaIcon },
  { name: "Azerbaijan", coords: [40.1431, 47.5769], icon: azerbaijanIcon },
  { name: "Italy", coords: [41.87194, 12.56738], icon: italyIcon },
  { name: "Spain", coords: [40.463667, -3.74922], icon: spainIcon },
  { name: "Netherlands", coords: [52.132633, 5.291266], icon: netherlandsIcon },
  { name: "Ireland", coords: [53.41291, -8.24389], icon: irelandIcon },
  { name: "Denmark", coords: [56.26392, 9.501785], icon: denmarkIcon },
  { name: "Slovakia", coords: [48.669026, 19.699024], icon: slovakiaIcon },
  { name: "Norway", coords: [63.99056, 12.30778], icon: norwayIcon },
  { name: "Sweden", coords: [62.3875, 16.3220], icon: swedenIcon },
  { name: "Finland", coords: [64.9147, 26.0673], icon: finlandIcon },
  { name: "Estonia", coords: [58.5953, 25.0136], icon: estoniaIcon },
  { name: "Latvia", coords: [56.8796, 24.6032], icon: latviaIcon },
  { name: "Lithuania", coords: [55.1694, 23.8813], icon: lithuaniaIcon },
  { name: "Kosovo", coords: [42.6026, 20.9020], icon: kosovoIcon },
  { name: "Montenegro", coords: [42.7360, 19.2594], icon: montenegroIcon },
  { name: "Croatia", coords: [45.1667, 15.5000], icon: croatiaIcon },
  { name: "Slovenia", coords: [46.1186, 14.8092], icon: sloveniaIcon },
  { name: "Bosnia and Herzegovina", coords: [43.9159, 17.6791], icon: bosniaIcon },
  { name: "Albania", coords: [41.1533, 20.1683], icon: albaniaIcon },
  { name: "North Macedonia", coords: [41.6086, 21.7453], icon: macedoniaIcon },
  { name: "Bulgaria", coords: [42.7339, 25.4858], icon: bulgariaIcon },
  { name: "Serbia", coords: [44.0165, 21.0059], icon: serbiaIcon },
  { name: "Romania", coords: [45.9432, 24.9668], icon: romaniaIcon },
  { name: "Moldova", coords: [47.4116, 28.3699], icon: moldovaIcon },
  { name: "India", coords: [20.5937, 78.9629], icon: indiaIcon },
  { name: "Uzbekistan", coords: [41.3775, 64.5853], icon: uzbekistanIcon },
  { name: "Turkey", coords: [38.9637, 35.2433], icon: turkeyIcon },
  { name: "Malaysia", coords: [4.2105, 101.9758], icon: malaysiaIcon },
  { name: "Thailand", coords: [15.8700, 100.9925], icon: thailandIcon },
  { name: "Indonesia", coords: [-0.7893, 113.9213], icon: indonesiaIcon },
  { name: "United Kingdom", coords: [54.0022, -2.5420], icon: ukIcon },
  { name: "Czech Republic", coords: [49.817492, 15.472962], icon: czechRepublicIcon },
  { name: "Poland", coords: [51.919438, 19.145136], icon: polandIcon },
  { name: "Hungary", coords: [47.162494, 19.503304], icon: hungaryIcon },
  { name: "Greece", coords: [39.074208, 21.824312], icon: greeceIcon },
  { name: "Portugal", coords: [39.399872, -8.224454], icon: portugalIcon },
];
